import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
export default new Vuex.Store({
    state: {
        cropperShow: false
    },
    mutations: {
        modify(state, Payload) {
            state[Payload.key] = Payload.value;
        }
    },
    getters: {},
    actions: {},
    modules: {}
})


// WEBPACK FOOTER //
// ./src/store/index.js